// Import model
import { UpdateContactNoteRequest } from '../models/UpdateContactNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateContactNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateContactNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateContactNoteRequest instance
   */
  static deserialize(json: string): UpdateContactNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateContactNoteRequest instance
   */
  static fromObject(obj: any): UpdateContactNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateContactNoteRequest');
    }


    const instance: UpdateContactNoteRequest = {
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      content: obj['content'] as string | undefined,
      description: obj['description'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateContactNoteRequest instances
   */
  static deserializeArray(json: string): UpdateContactNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateContactNoteRequest instance to a JSON string
   */
  static serialize(instance: UpdateContactNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateContactNoteRequest instance to a plain object
   */
  static toObject(instance: UpdateContactNoteRequest): any {
    return {
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'content': instance.content,
      'description': instance.description,
      'contentType': instance.contentType,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of UpdateContactNoteRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateContactNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
